import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type CustomiseErrorBoundaryClasses = 'container' | 'backButton';

const customiseErrorBoundaryStyles = makeStyles<ISpcTheme, CustomiseErrorBoundaryClasses>(
  () => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    backButton: {
      margin: '8px 0',
    },
  }),
  { name: 'Customise_CustomiseErrorBoundary' },
);

export default customiseErrorBoundaryStyles;
